<template>
  <div class="home" v-loading="loading">
    <div class="header">
      <!-- 添加区域 -->
      <div class="add" @click="addition">
        <img class="ioc" src="../../assets/common/common-add.png" />
        <div class="addtext">添加</div>
      </div>
    </div>

    <div class="header-table">
      <el-table
        :data="tableData"
        border
        style="width: 100%; cursor: pointer"
        :header-cell-style="{
          color: '#333333',
          backgroundColor: '#FAFAFA',
        }"
      >
        <!-- 自定义暂无数据 -->
        <template slot="empty">
          <div class="empty-block">
            <img
              class="empty-block-img"
              src="../../assets/common/common-empty.png"
            />
            <div class="empty-block-text">暂无数据～</div>
          </div>
        </template>
        <el-table-column prop="name" label="搜索名称"> </el-table-column>
        <el-table-column prop="admin_name" label="最后编辑id名称" width="240">
        </el-table-column>
        <el-table-column label="操作" width="198">
          <template slot-scope="scope">
            <div class="table-display">
              <div class="table-operation" @click="compileBtn(scope.row)">
                编辑
              </div>

              <div class="table-operation" @click="deteleBtn(scope.row)">
                删除
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!--添加-->
    <div class="addition">
      <el-dialog
        :visible.sync="additionDialogVisible"
        style="margin-top: 10vh"
        @close="additionReset"
        :style="{
          '--height': additionError == false ? '1.09375rem' : '1.25rem',
        }"
      >
        <span slot="footer" class="dialog-footer">
          <div class="addition-div">
            <div class="addition-div-top">
              <div class="addition-div-top-title">
                {{ additionId == '' ? '添加' : '编辑' }}
              </div>
              <img
                class="addition-div-top-img"
                src="../../assets/common/close.png"
                @click="additionReset"
              />
            </div>

            <div class="addition-div-hinh" v-if="additionError == true">
              <div class="addition-div-hinh-title">
                {{
                  additionSensitive == ''
                    ? '抱歉，搜索名称添加不能为空!'
                    : '抱歉，搜索名称不可超10个字'
                }}
              </div>
            </div>

            <div class="addition-div-center">
              <div class="addition-div-center-title">搜索名称</div>
              <div class="addition-div-center-input">
                <el-input
                  placeholder="搜索名称不可超10个字"
                  v-model="additionSensitive"
                  clearable
                >
                </el-input>
              </div>
            </div>

            <div class="addition-div-button">
              <!-- <div class="button-reset" @click="additionReset">重置</div> -->
              <div class="button-confirm" @click="additionConfirm">确定</div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>

    <!--删除 -->
    <div class="detele">
      <el-dialog
        :visible.sync="deteleDialogVisible"
        width="394px"
        style="margin-top: 10vh"
        @close="cancelDetele"
      >
        <span slot="footer" class="dialog-footer">
          <div class="detele-div">
            <img
              class="detele-div-img"
              src="../../assets/common/common-warning.png"
            />
            <div class="detele-div-title">是否删除该搜索内容名称信息？</div>
            <div class="detele-div-button">
              <div class="detele-div-button-left" @click="confirmDetele">
                确定
              </div>
              <div class="detele-div-button-right" @click="cancelDetele">
                取消
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  getsearch,
  getsearchAdd,
  getsearchDetail,
  deletefnsearchDetail,
} from '../../api/common'

export default {
  comments() {},
  data() {
    return {
      // 添加弹出框 开启
      additionDialogVisible: false,
      // 添加敏感词
      additionSensitive: '',
      // 添加或者编辑id
      additionId: '',
      // 添加或者编辑失败
      additionError: false,
      // 删除弹出框
      deteleDialogVisible: false,
      /* end */
      // 表格数组
      tableData: [],
      // 表格总条数
      totalNum: 0,
      // 页码
      page: 1,
      // 页数
      limit: 10,
      // 刷新
      loading: false,
      // 控制当前页面功能性按钮开关
      basicFunShow: false,
    }
  },
  created() {
    this.loading = true
    this.getsearchClick()

    setTimeout(() => {
        this.basicFunShow = this.$store.state.pageFunctionShow
    }, 1000);
  },
  methods: {
    // 获取通知列表接口
    getsearchClick() {
      let params = {
        pageSize: this.limit,
        pageNo: this.page,
      }

      getsearch(params).then((res) => {
        if (res.resultStatus == true) {
          console.log('获取接口返回', res)
          // 获取表格数据
          this.tableData = res.resultData.searchList
          // 获取表格总条数
          this.totalNum = res.resultData.totalNum
          this.loading = false
        }
      })
    },

    // 添加  开启弹出框
    addition() {
      if (this.basicFunShow == false) {
        return
      }
      this.additionError = false
      this.additionDialogVisible = true
    },
    // 添加弹出框  确定
    additionConfirm() {
      if (this.additionSensitive != '' && this.additionSensitive.length <= 10) {
        let params = {
          id: this.additionId,
          name: this.additionSensitive,
        }

        getsearchAdd(params).then((res) => {
          if (res.resultStatus == true) {
            this.loading = true
            this.$message({
              message: this.additionId == '' ? '添加成功！' : '修改成功！',
              type: 'success',
            })
            this.additionError = false
            this.getsearchClick()
            this.additionDialogVisible = false
          }
        })
      } else {
        this.additionError = true
      }
    },
    // 添加弹出框  重置
    additionReset() {
      this.additionId = ''
      this.additionError = false
      this.additionSensitive = ''
      this.additionDialogVisible = false
    },

    // 编辑
    compileBtn(item) {
      if (this.basicFunShow == false) {
        return
      }

      console.log('开启', item)
      let params = item.id

      getsearchDetail(params).then((res) => {
        if (res.resultStatus == true) {
          this.additionId = item.id
          this.additionSensitive = item.name
          this.additionError = false
          this.additionDialogVisible = true
        }
      })
    },

    // 删除
    deteleBtn(item) {
      if (this.basicFunShow == false) {
        return
      }

      this.additionId = item.id
      this.deteleDialogVisible = true
    },

    // 删除弹出框 确定
    confirmDetele() {
      let params = this.additionId

      deletefnsearchDetail(params).then((res) => {
        if (res.resultStatus == true) {
          this.$message({
            message: '删除成功！',
            type: 'success',
          })

          this.loading = true
          this.deteleDialogVisible = false
          this.getsearchClick()
        }
      })
    },
    // 删除弹出框 取消
    cancelDetele() {
      this.additionId = ''
      this.deteleDialogVisible = false
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .el-input__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
}

.home {
  margin: 0 auto;
  background-color: #f4f5f9;
  min-height: 900px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px #edeff7;
  border-radius: 10px;
}
.header {
  height: 80px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  box-sizing: border-box;

  .add {
    width: 82px;
    height: 36px;
    background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    .ioc {
      width: 13px;
      height: 13px;
    }
    .addtext {
      margin-left: 8px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }
}

.header-table {
  padding: 0 24px;
  box-sizing: border-box;
  /deep/ .el-table thead {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #333333;
    background: #d8d8d8;
  }

  /deep/ .el-table tr {
    height: 46px;
  }

  /deep/ .el-table__empty-text {
    line-height: 0;
  }

  .empty-block {
    margin-top: 62px;
    padding-bottom: 40px;
    .empty-block-img {
      width: 130px;
      height: 130px;
      margin: 0 auto;
    }

    .empty-block-text {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      margin-top: 10px;
      height: 17px;
      line-height: 17px;
    }
  }

  .table-display {
    display: flex;
    .table-operation {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #2aa4ff;
      text-decoration: underline;
    }

    .table-operation:nth-child(2) {
      margin-left: 24px;
    }
  }
}

/* 添加弹出框 */
.addition {
  /deep/ .el-dialog {
    width: 444px;
    height: var(--height) !important;
  }

  /deep/ .el-dialog__footer {
    padding: 0;
    text-align: left;
  }

  .addition-div {
    background: #ffffff;
    box-shadow: 0px 12px 48px 16px rrgba(134, 77, 77, 0.03) 0px 9px 28px 0px
        rgba(0, 0, 0, 0.05),
      0px 6px 16px -8px rgba(0, 0, 0, 0.08);
    border-radius: 10px;
    .addition-div-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 56px;
      padding: 0 24px;
      box-sizing: border-box;
      border-bottom: 1px solid #d9d9d9;
      .addition-div-top-title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #222222;
      }

      .addition-div-top-img {
        width: 10px;
        height: 10px;
      }
    }

    .addition-div-hinh {
      display: flex;
      height: 30px;
      align-items: center;
      padding: 0 24px;
      box-sizing: border-box;
      background: rgba(249, 182, 60, 0.1);
      .addition-div-hinh-title {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ed6d1f;
      }
    }

    .addition-div-center {
      padding: 0 24px;
      box-sizing: border-box;
      margin-top: 20px;
      .addition-div-center-title {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }

      .addition-div-center-input {
        margin-top: 4px;
        width: 100%;
        /deep/ .el-input {
          height: 32px;
        }

        /deep/ .el-input__inner {
          padding: 0 10px;
          box-sizing: border-box;
          height: 32px;
          background-color: rgba(255, 255, 255, 0);
        }
      }
    }

    .addition-div-button {
      margin-top: 24px;
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 16px;
      box-sizing: border-box;
      border-top: 1px solid #d9d9d9;

      .button-reset,
      .button-confirm {
        width: 65px;
        height: 32px;
        background: #ffffff;
        border-radius: 10px;
        border: 1px solid #e9edf4;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #555555;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
      }

      .button-confirm {
        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
        color: #ffffff;
        margin-left: 8px;
      }
    }
  }
}

// 删除
.detele {
  /deep/ .el-dialog {
    height: 230px;
  }

  /deep/ .el-dialog__footer {
    padding: 25px 0;
    box-sizing: border-box;
  }

  .detele-div {
    width: 100%;
    text-align: center;
    .detele-div-img {
      width: 56px;
      height: 56px;
      margin: 0 auto;
    }

    .detele-div-title {
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.85);
      margin-top: 8px;
    }

    .detele-div-button {
      display: flex;
      justify-content: center;
      align-content: center;
      margin-top: 40px;

      .detele-div-button-left,
      .detele-div-button-right {
        width: 88px;
        height: 32px;
        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
        border-radius: 10px;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }

      .detele-div-button-right {
        margin-left: 8px;
        border: 1px solid #e9edf4;
        color: rgba(0, 0, 0, 0.65);
        background: #ffffff;
      }
    }
  }
}
</style>
